(function () {
  function createPlayer(player) {
    if (player.dataset.playerInitialized === 'true') return;

    var iframe = document.createElement('iframe');
    iframe.className = 'youtube-short-with-content__frame';
    iframe.width = '315';
    iframe.height = '560';
    iframe.src = player.dataset.embedUrl;
    iframe.title = player.dataset.frameTitle || 'YouTube Short video';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    player.dataset.playerInitialized = 'true';
    player.replaceChildren(iframe);
  }

  function initialize(root) {
    var players = [];

    if (root.matches && root.matches('[data-youtube-short-player]')) {
      players.push(root);
    }

    if (root.querySelectorAll) {
      players = players.concat(Array.prototype.slice.call(root.querySelectorAll('[data-youtube-short-player]')));
    }

    players.forEach(function (player) {
      if (player.dataset.playerBound === 'true') return;

      var button = player.querySelector('.youtube-short-with-content__play-button');
      if (!button) return;

      player.dataset.playerBound = 'true';
      button.addEventListener('click', function () {
        createPlayer(player);
      });
    });
  }

  initialize(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
